import clsx from 'clsx';
import React from 'react';

import YouTubePlayer from '@components/pages/PageTemplates/Blocks/VideoBlock/YouTube';

import { MAX_YOUTUBE_VIDEO_WIDTH } from './constants';

interface TITVSectionProps {
  className?: string;
  latestTITVEpisodeID?: string;
}

const TITVSection = ({ className, latestTITVEpisodeID }: TITVSectionProps) => {
  const youtubeURL = `https://youtu.be/${latestTITVEpisodeID}`;

  return (
    <section className={clsx('pt-64 sm:pt-112', className)}>
      <div className="mx-auto flex max-w-[500px] flex-col items-center">
        <h2 className="m-0 text-center font-suisse-works text-headline-sm text-primary-black sm:text-headline-lg">
          The Information’s TITV
        </h2>
        <p className="m-0 text-center font-suisse-intl-mono text-caption-md text-primary-black">
          Weekdays at 10 am PT / 1 pm ET
        </p>
        <p className="m-0 mt-24 text-center font-suisse-neue text-body-lg text-primary-black">
          The Information’s TITV is first in tech news and analysis from the people who break and
          shape the story. The rest is just commentary.
        </p>
      </div>
      <div className="mt-32">
        <div
          aria-label="TITV video preview"
          className="mx-auto flex aspect-[16/9] h-full w-full max-w-[750px] items-center justify-center"
          role="img"
        >
          <YouTubePlayer content={{ src: youtubeURL }} maxWidth={MAX_YOUTUBE_VIDEO_WIDTH} />
        </div>
      </div>
    </section>
  );
};

export default TITVSection;
